<template>
  <div class="create-activity">
    <a-steps :current="current">
      <a-step v-for="(item, i) in steps" :key="i" :title="item.title" :description="item.description" />
    </a-steps>
    <div class="create-activity-content">
      <div class="flex-grow scroll-area" v-if="current == 0">
        <form-area
          ref="activityForm"
          class="flex-box vertical"
          layout="horizontal"
          hide-btn
          :label-col="{span: 5}"
          :wrapper-col="{span: 19}"
          :items="items"
          :entity="form"
          confirm-text="提交"></form-area>
      </div>
      <staff-set class="flex-grow create-activity-box" v-else-if="current == 1"></staff-set>
      <create-charge
        class="flex-grow create-activity-box"
        :user="draft ? draft.plan_personnel: undefined"
        :group="draft ? draft.plan_group: undefined"
        @user="handleChange($event, 'plan_personnel')"
        @group="handleChange($event, 'plan_group')"
        v-else-if="current == 2"></create-charge>
      <create-schedule
        create
        class="flex-grow"
        :value="draft ? draft.schedule: undefined"
        @change="handleChange($event, 'schedule')"
        v-else-if="current == 3"></create-schedule>
      <div class="flex-grow create-activity-box" v-else-if="current == 4">
        <a-result status="success" title="创建成功">
          <template #extra>
            <a-button type="primary" @click="goActivity">查看详情</a-button>
          </template>
        </a-result>
      </div>
      <a-space class="footer" v-if="current < 4">
        <a-button @click="cancel">返回</a-button>
        <a-button @click="prev">上一步</a-button>
        <a-button type="primary" :loading="btn == 'save' && loading" @click="save">保存</a-button>
        <a-button type="primary" :loading="btn == 'next' && loading" @click="next">{{ current == 3 ? '完成' : '下一步' }}</a-button>
      </a-space>
    </div>
  </div>
</template>

<script>
import StaffSet from "./StaffSet";
import CreateCharge from "./CreateCharge";
import CreateSchedule from "./CreateSchedule";
import {activityFormItems} from "../../../common/activity/activity";
import {getUserId} from "../../../common/js/storage";
import {omit} from "../../../common/js/tool";

export default {
    name: "CreateActivity",
    components: {
        StaffSet,
        CreateCharge,
        CreateSchedule,
    },
    data() {
        return {
            steps: [
                {
                    title: '基本信息',
                    description: '填写活动基本信息',
                },
                {
                    title: '添加人员',
                    description: '添加外部人员信息',
                },
                {
                    title: '设置统筹人',
                    description: '设置统筹人、统筹小组',
                },
                {
                    title: '活动日程',
                    description: '设置活动日程、任务分工',
                },
                {
                    title: '创建完成',
                    description: '活动创建完成',
                }
            ],
            current: 0,
            form: {},
            items: activityFormItems,
            draft: null, // 活动信息草稿
            btn: '',
            loading: false,
            changed: false
        }
    },
    computed: {
        activity() {
            return this.$store.getters.activity;
        },
        id() {
            return this.$route.params.id;
        }
    },
    watch: {
        activity() {
            this.setInfo();
        }
    },
    created() {
        this.$store.commit("setActivity", null);
        // window.addEventListener("beforeunload", this.handleBeforeunload);
        this.getActivity();
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.handleBeforeunload);
    },
    methods: {
        getActivity() {
            const id = this.id;
            const activity = this.activity;
            if(id !== "new") {
                if(activity && activity.id == id) {
                    this.setInfo();
                } else {
                    this.$axios(`/activity/activity/${id}`).then(res => {
                        res.charge_status = 1;
                        this.$store.commit("setActivity", res);
                    });
                }
            }
        },
        setInfo() {
            const activity = this.activity;
            if(activity) {
                if(activity.activity_snap) {
                    try {
                        const draft = JSON.parse(activity.activity_snap);
                        this.current = draft.step || 0;
                        this.draft = draft;
                    } catch (e) {
                        console.error(e)
                    }
                }
                const form = {};
                activityFormItems.forEach(item => {
                   if(item.key == "time") {
                       form.time = [activity.start_time, activity.end_time];
                   } else if(item.key == "files") {
                       form.files = activity.file ? JSON.parse(activity.file) : null;
                   } else {
                       form[item.key] = activity[item.key];
                   }
                });
                this.form = form
            }
        },
        handleChange(data, key) {
            if(this.draft) {
                this.$set(this.draft, key, data);
            } else {
                const draft = {};
                draft[key] = data;
                this.draft = draft;
            }
            this.changed = true;
        },
        handleBeforeunload(event) {
            // Cancel the event as stated by the standard.
            event.preventDefault();
            // Chrome requires returnValue to be set.
            event.returnValue = "";
        },
        goActivity() {
            this.$router.push({name: 'ActivityInfo', params: {id: this.activity.id}});
        },
        cancel() {
            this.$confirm({
                title: "提示",
                content: "返回后该页面不会保存，如已保存请忽略，确认返回？",
                centered: true,
                onOk: () => {
                    this.$router.go(-1);
                },
            });
        },
        prev() {
            this.current -= 1;
        },
        getDraft(next) {
            const draft = this.draft;
            const data = {
                step: next ? this.current + 1 : this.current
            };
            if(draft) {
                if(draft.plan_personnel) {
                    data.plan_personnel = {
                        name: draft.plan_personnel.name,
                        tel: draft.plan_personnel.tel,
                    }
                }
                if(draft.plan_group && draft.plan_group.length > 0) {
                    data.plan_group = draft.plan_group.map(item => Object({name: item.name, tel: item.tel}));
                }
                draft.schedule && (data.schedule = draft.schedule);
            }
            return JSON.stringify(data);
        },
        save(next) {
            const isNext = next === true;
            this.btn = isNext ? "next" : "save";
            if(this.loading) return;
            const current = this.current;
            if(current == 0) {
                this.loading = true;
                return this.$refs.activityForm.handleConfirm().then(form => {
                    const data = omit(form, ['time', 'files']);
                    data.start_time = form.time[0];
                    data.end_time = form.time[1];
                    data.create_user_id = getUserId();
                    data.file = form.files ? JSON.stringify(form.files) : null;
                    data.activity_snap = this.getDraft(isNext);
                    return this.saveActivity(data);
                }).catch(() => this.loading = false);
            } else {
                this.loading = true;
                const data = {
                    activity_snap: this.getDraft(isNext)
                };
                return this.saveActivity(data, this.current == 3 && isNext);
            }
        },
        saveActivity(data, complete) {
            const activity = this.activity;
            let url = '/activity/activity', method = 'POST';
            if(activity) {
                url += `/${activity.id}`;
                method = 'PATCH';
            }
            if(complete) {
                data.next = 1;
                data.status = 1;
            }
            return this.$axios({
                url,
                method,
                data
            }).then(res => {
                res.charge_status = 1;
                if (activity) {
                    res = {...activity, ...res};
                }
                this.$store.commit("setActivity", res);
            }).finally(() => {
                this.loading = false;
            });
        },
        next() {
            this.save(true);
        }
    }
}
</script>

<style lang="less">
.create-activity {
  display: flex;
  flex-direction: column;
  margin: 16px auto;
  width: 1200px;
}
.create-activity-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  min-height: 0;
  background-color: @body-background;
  box-shadow: @box-shadow-base;
  .footer {
    margin-top: 0;
  }
}
.create-activity-box {
  padding: @padding-md;
  min-height: 0;
}
</style>
